'use client'

import React, { useState, useEffect, useRef, memo } from 'react'

import Base from './variants/AccordionBase.component'
import TwoColumns from './variants/AccordionTwoColumns.component'
import Event from './variants/AccordionEvent.component'

import {
  open as openAnimation,
  close as closeAnimation,
} from '../../../animations/accordion'

const normalizedComponents = {
  base: Base,
  twoColumns: TwoColumns,
  event: Event
}

const AccordionSub = ({
  id,
  colorScheme,
  variant = 'base',
  data,
  disabled,
  parentHandler,
  open,
}) => {
  const [accordion, setAccordion] = useState({
    open,
    isAnimating: false,
  })

  const refs = {
    wrapper: useRef(null),
    header: useRef(null),
    content: useRef(null),
  }

  const Component = normalizedComponents[variant]

  useEffect(() => {
    setAccordion((previousState) => ({
      ...previousState,
      open,
    }))
  }, [open])

  useEffect(() => {
    handleAnimation(accordion)
  }, [accordion.open, data])

  const handleAnimation = (accordion) => {
    if (accordion.open) {
      openAnimation(refs, () => {
        setAccordion((previousState) => ({
          ...previousState,
          isAnimating: false,
        }))
      })
    } else {
      closeAnimation(refs, () => {
        setAccordion((previousState) => ({
          ...previousState,
          isAnimating: false,
        }))
      })
    }
  }

  const handleClick = ({ open, isAnimating }) => {
    if (isAnimating || disabled) return
    setAccordion({
      open: !open,
      isAnimating: true,
    })
    if (typeof parentHandler === 'function') parentHandler()
  }

  return (
    <Component
      {...data}
      id={id}
      colorScheme={colorScheme}
      refs={refs}
      accordion={accordion}
      handleClick={handleClick}
      key={'accordionDispatcher' + data.id}
    />
  )
}

export default memo(AccordionSub)
